import React from 'react';
import { useCalculationEdit } from './useCalculationEdit';
import { Button, Row } from '@ydistri/ds';
import EditRedistributionBackupInfo from './EditRedistributionBackupInfo';
import { Popover } from 'antd';

interface BackupOrRemoveButtonProps {
  calculationId: number;
  onClick: () => void;
  loading: boolean;
}

const BackupOrRemoveButton: React.FC<BackupOrRemoveButtonProps> = ({
  calculationId,
  onClick,
  loading,
}) => {
  const { canEdit, disabledTooltipMessage } = useCalculationEdit(calculationId);

  return canEdit ? (
    <Row $flexGrow={1} $justifyContent="end">
      <Popover content={disabledTooltipMessage}>
        <Button loading={loading} onClick={onClick} disabled={disabledTooltipMessage !== undefined}>
          Remove from redistribution
        </Button>
      </Popover>
    </Row>
  ) : (
    <EditRedistributionBackupInfo calculationId={calculationId} />
  );
};

export default BackupOrRemoveButton;
